<div class="card mb-3">
  <div class="card-body">
    <form>
      <div class="row">
        <div class="col mb-3">
          <label class="form-label px-2" for="publishDate">{{
            'pages.support.dashboard.fieldTitles.createdToFrom' | translate
          }}</label>
          <div class="row gy-1">
            <div class="col">
              <input
                type="date"
                class="form-control"
                name="createdFrom"
                aria-describedby="createdFrom"
                [(ngModel)]="globalFilters.createdFrom"
                (change)="onCreatedPeriodChange()"
              />
            </div>
            <div class="col createdTo">
              <input
                type="date"
                class="form-control"
                name="createdTo"
                aria-describedby="createdTo"
                [(ngModel)]="globalFilters.createdTo"
                (change)="onCreatedPeriodChange()"
              />
            </div>
          </div>
        </div>
        <div class="col mb-3">
          <label class="form-label" for="publishDate">{{
            'pages.support.dashboard.fieldTitles.created' | translate
          }}</label>
          <select
            class="form-select"
            name="createdPeriod"
            aria-describedby="createdPeriod"
            [(ngModel)]="globalFilters.createdPeriod"
            (change)="globalFilters.applyPeriod()"
          >
            <option></option>
            <option value="1w">
              {{ 'pages.generic.thisWeek' | translate }}
            </option>
            <option value="2w">
              {{ 'pages.generic.lastTwoWeeks' | translate }}
            </option>
            <option value="thismonth">
              {{ 'pages.generic.thisMonth' | translate }}
            </option>
            <option value="lastmonth">
              {{ 'pages.generic.lastMonth' | translate }}
            </option>
            <option value="last6month">
              {{ 'pages.generic.last6months' | translate }}
            </option>
          </select>
        </div>
        <div class="col mb-3">
          <label class="form-label px-2" for="filters">{{
            'pages.generic.filter' | translate
          }}</label>
          <div class="row gy-1">
            <div ngbDropdown class="col-12">
              <button
                class="btn btn-info btn-dropdown"
                id="dropdownMenu1"
                ngbDropdownToggle
              >
                {{
                  'pages.cybersocxdr.dashboard.fieldTitles.severity' | translate
                }}
              </button>
              <div ngbDropdownMenu aria-labelledby="dropdownMenu1">
                <div class="my-1 mx-1 form-check">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="globalFilters.severitys[0][1]"
                    [(ngModel)]="globalFilters.severitys[0][1]"
                    [ngModelOptions]="{ standalone: true }"
                  />
                  <label
                    class="form-check-label"
                    for="globalFilters.severitys[0][1]"
                    >{{ 'menu.reports.lowPriority' | translate }}</label
                  >
                </div>
                <div class="my-1 mx-1 form-check">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="globalFilters.severitys[1][1]"
                    [(ngModel)]="globalFilters.severitys[1][1]"
                    [ngModelOptions]="{ standalone: true }"
                  />
                  <label
                    class="form-check-label"
                    for="globalFilters.severitys[1][1]"
                    >{{ 'menu.reports.mediumPriority' | translate }}</label
                  >
                </div>
                <div class="my-1 mx-1 form-check">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="globalFilters.severitys[2][1]"
                    [(ngModel)]="globalFilters.severitys[2][1]"
                    [ngModelOptions]="{ standalone: true }"
                  />
                  <label
                    class="form-check-label"
                    for="globalFilters.severitys[2][1]"
                    >{{ 'menu.reports.highPriority' | translate }}</label
                  >
                </div>
                <div class="my-1 mx-1 form-check">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    id="globalFilters.severitys[3][1]"
                    [(ngModel)]="globalFilters.severitys[3][1]"
                    [ngModelOptions]="{ standalone: true }"
                  />
                  <label
                    class="form-check-label"
                    for="globalFilters.severitys[3][1]"
                    >{{ 'menu.reports.criticalPriority' | translate }}</label
                  >
                </div>
              </div>
            </div>
            <app-searchabledropdown
              title="Status"
              [items]="globalFilters.status"
            />
          </div>
        </div>
        <div *ngIf="globalFilters.repartitionLevels" class="col mb-3">
          <label class="form-label px-2" for="repartition">{{
            'pages.cybersocxdr.filters.repartition' | translate
          }}</label>
          <div class="row gy-1">
            <div
              *ngIf="globalFilters.repartitionLevels.length > 0"
              class="col-12"
            >
              <app-searchabledropdown
                [title]="globalFilters.groupByNames[0] | titlecase"
                [items]="globalFilters.repartitionLevels[0]"
              />
            </div>
            <div
              *ngIf="globalFilters.repartitionLevels.length > 1"
              ngbDropdown
              class="col-12"
            >
              <app-searchabledropdown
                [title]="globalFilters.groupByNames[1] | titlecase"
                [items]="globalFilters.repartitionLevels[1]"
              />
            </div>
          </div>
        </div>

        <div [ngbCollapse]="!advSearch" id="advSearch" class="row">
          <div class="col mb-3">
            <label class="form-label" for="">{{
              'pages.cybersocxdr.dashboard.caseNumber' | translate
            }}</label>
            <input
              type="text"
              class="form-control"
              name="caseNumber"
              [(ngModel)]="caseNumber"
              aria-describedby=""
            />
          </div>
          <div class="col mb-3">
            <label class="form-label" for="">{{
              'pages.cybersocxdr.dashboard.subject' | translate
            }}</label>
            <input
              type="text"
              class="form-control"
              name="subject"
              [(ngModel)]="subject"
              aria-describedby=""
            />
          </div>

          <div class="col mb-3">
            <label class="form-label px-2" for="advancedsearch">{{
              'pages.generic.advancedSearch' | translate
            }}</label>
            <div class="row gy-1">
              <div ngbDropdown class="col">
                <app-searchabledropdown
                  title="Category"
                  [items]="globalFilters.categories"
                />
              </div>
              <div ngbDropdown class="col">
                <app-searchabledropdown
                  title="Owner"
                  emptyItemLabel="Unassigned"
                  [items]="globalFilters.owners"
                />
              </div>
              <div ngbDropdown class="col">
                <app-searchabledropdown
                  title="Waiting for"
                  [items]="globalFilters.waitingFor"
                />
              </div>
              <div ngbDropdown class="col">
                <app-searchabledropdown
                  title="Closure verdict"
                  [items]="globalFilters.closureVerdict"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class="card-title float-end row w-50 justify-content-end"
        style="display: inline-flex"
        *ngIf="handleAdvSearch !== false"
      >
        <div
          class="col-6 form-check form-switch"
          data-toggle="tooltip"
          data-placement="top"
          title="{{ 'pages.support.dashboard.enableAdSearchDesc' | translate }}"
        >
          <input
            class="form-check-input me-2"
            type="checkbox"
            id="advanceSearch"
            role="switch"
            [(ngModel)]="advSearch"
            [ngModelOptions]="{ standalone: true }"
          />
          <label class="form-check-label" for="advanceSearch"
            >{{ 'pages.generic.advancedSearch' | translate }}
          </label>
        </div>
        <div
          class="col-6 form-check form-switch"
          data-toggle="tooltip"
          data-placement="top"
          title="{{
            'pages.support.dashboard.enableSavedSearchDeas' | translate
          }}"
        >
          <input
            class="form-check-input me-2"
            type="checkbox"
            role="switch"
            id="hideSaveSearch"
            [(ngModel)]="savedSearches"
            [ngModelOptions]="{ standalone: true }"
            disabled
          />
          <label class="form-check-label" for="hideSaveSearch">{{
            'pages.generic.savedSearches' | translate
          }}</label>
        </div>
      </div>
      <div>
        <button class="btn btn-primary me-1" (click)="search()">
          {{ 'pages.generic.filter' | translate }}
        </button>
        <button class="btn btn-primary me-1" (click)="reset()">
          {{ 'pages.generic.reset' | translate }}
        </button>
        <button
          class="btn btn-primary"
          (click)="generatePdf()"
          *ngIf="handlePdfExport === true"
        >
          {{ 'pages.cybersocxdr.filters.generateReport' | translate }}
        </button>
      </div>
    </form>
  </div>
</div>
<div class="card mb-3" [ngbCollapse]="!savedSearches">
  <div class="card-body p-1">
    <span style="float: left">
      <button class="btn btn-primary">
        test <fa-icon [icon]="['fas', 'trash']" class="pl-2"></fa-icon>
      </button>
    </span>
  </div>
</div>
